// extracted by mini-css-extract-plugin
export default {"wrapper":"Projects_wrapper__9IbXO"};